export default __webpack_public_path__ + "static/Lens_Zannis-Kalampoukis_Sr-Software-Eng-c6f90a4104658d43b2c03fe57a15a603.jpeg";